module.exports = {
	"pagination": {
		"DescribeTrails": {
			"result_key": "trailList"
		},
		"LookupEvents": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Events"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cloudtrail-2013-11-01.paginators.json
// module id = 747
// module chunks = 38